import { render, staticRenderFns } from "./CustomPopup.vue?vue&type=template&id=d7513b54&scoped=true&"
import script from "./CustomPopup.vue?vue&type=script&lang=js&"
export * from "./CustomPopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomPopup.vue?vue&type=style&index=0&id=d7513b54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7513b54",
  null
  
)

export default component.exports